import React, { memo, useCallback, useMemo, useState } from 'react';
import { Icon, Table } from 'antd';
import { StyledTalFigurativeWrapper } from '../../../styled-components/product/try-aibility/tal-figurative';

const TalFigurative = memo(() => {
  const staticData = useMemo(() => {
    return {
      columns: [
        {
          title: '词性',
          dataIndex: 'type',
          width: 90
        },
        {
          title: '词汇详情',
          dataIndex: 'detail',
          ellipsis: true,
          render: (text) => {
            return <span>{text.length ? text.join('、') : '/'}</span>;
          }
        }
      ],
      data: [
        {
          input:
            '暑假的时候，爸爸妈妈带我去了长城，那次是我印象最深刻的一次旅游了，长城蜿蜒起伏像一条巨大的龙，一眼也看不到尽头，太酷啦！长城有好多好多的台阶，爸爸一直牵着我的手，怕我摔倒，爸爸还说是好汉就要爬到好汉坡。我爬呀爬呀，终于到了好汉坡，我觉得非常自豪。等我长大后，我也要像长城一样，做保家卫国的男子汉！',
          result: [
            {
              key: '1',
              type: '名词',
              detail: [
                '爸爸妈妈',
                '长城',
                '时候',
                '带我去',
                '台阶',
                '印象',
                '龙',
                '男子汉',
                '好汉坡',
                '手',
                '爸爸',
                '长大',
                '好汉',
                '自豪'
              ]
            },
            {
              key: '2',
              type: '动词',
              detail: [
                '是',
                '摔倒',
                '觉得',
                '看不到',
                '要',
                '有',
                '做',
                '旅游',
                '起伏',
                '到',
                '怕',
                '像',
                '爬',
                '说',
                '蜿蜒',
                '牵'
              ]
            },
            {
              key: '3',
              type: '形容词',
              detail: ['太酷', '巨大']
            },
            {
              key: '4',
              type: '成语',
              detail: ['保家卫国']
            },
            {
              key: '5',
              type: '副词',
              detail: [
                '终于',
                '也',
                '一直',
                '还',
                '最',
                '尽头',
                '非常',
                '深刻',
                '就要'
              ]
            },
            {
              key: '6',
              type: '代词',
              detail: ['一样', '那次', '我']
            },
            {
              key: '7',
              type: '时间修饰词',
              detail: ['暑假']
            },
            {
              key: '8',
              type: '并列词',
              detail: []
            },
            {
              key: '9',
              type: '介词',
              detail: []
            }
          ],
          totalWords: 46,
          totalSent: 4
        },
        {
          input:
            '我最喜欢的动物是小狗，因为它活蹦乱跳的非常可爱。爷爷家就有一只小狗，一只肥头大耳的狗，它每次见到我都会摇着尾巴非常开心的向我跑来，并且它还会汪汪汪的叫，仿佛在跟我打招呼一样。我喜欢摸它，它的毛摸起来又软又温暖，它还有一点特别厉害！它可以接住我扔的小球，它可太棒了！我希望我的妈妈也可以给我养一只小狗，这样我每天都能和它在一起，因为我太喜欢小狗了！',
          result: [
            {
              key: '1',
              type: '名词',
              detail: [
                '爷爷',
                '小狗',
                '动物',
                '小球',
                '狗',
                '妈妈',
                '太棒了',
                '毛',
                '汪汪',
                '尾巴'
              ]
            },
            {
              key: '2',
              type: '动词',
              detail: [
                '能',
                '跑',
                '会',
                '见到',
                '是',
                '希望',
                '养',
                '起来',
                '还有',
                '扔',
                '可',
                '摇',
                '来',
                '有',
                '接住',
                '开心',
                '喜欢',
                '叫',
                '可爱',
                '摸',
                '打招呼'
              ]
            },
            {
              key: '3',
              type: '形容词',
              detail: ['温暖', '软', '厉害']
            },
            {
              key: '4',
              type: '成语',
              detail: ['肥头大耳', '活蹦乱跳']
            },
            {
              key: '5',
              type: '副词',
              detail: [
                '特别',
                '仿佛',
                '也',
                '就',
                '还',
                '最',
                '都',
                '非常',
                '太',
                '又'
              ]
            },
            {
              key: '6',
              type: '代词',
              detail: ['一样', '我', '每天', '这样', '每次', '它']
            },
            {
              key: '7',
              type: '时间修饰词',
              detail: []
            },
            {
              key: '8',
              type: '并列词',
              detail: ['并且', '因为', '和', '可以']
            },
            {
              key: '9',
              type: '介词',
              detail: []
            }
          ],
          totalWords: 56,
          totalSent: 4
        },
        {
          input:
            '我最喜欢的小动物是小白兔。小白兔人见人爱，它全身雪白，两只眼睛红红的，像红宝石一样光彩夺目，超级好看！它的四条腿也很有趣，前腿短，后腿长，跑起来一蹦一跳的。她身子后面还长着像小毛球一般的尾巴， 我希望将来有一天，我自己能养几只小白兔，我会让妈妈买胡萝卜给它，把它养的胖胖的！那肯定很有趣。',
          result: [
            {
              key: '1',
              type: '名词',
              detail: [
                '腿',
                '小毛',
                '动物',
                '腿短',
                '尾巴',
                '后腿',
                '胡萝卜',
                '身子',
                '小',
                '小白兔',
                '全身',
                '能养',
                '眼睛',
                '妈妈',
                '我会',
                '球',
                '红宝石'
              ]
            },
            {
              key: '2',
              type: '动词',
              detail: [
                '好看',
                '是',
                '希望',
                '养',
                '有',
                '肯定',
                '跑',
                '让',
                '喜欢',
                '像',
                '买',
                '起来',
                '还长'
              ]
            },
            {
              key: '3',
              type: '形容词',
              detail: ['有趣', '长', '一般']
            },
            {
              key: '4',
              type: '成语',
              detail: ['光彩夺目']
            },
            {
              key: '5',
              type: '副词',
              detail: ['最', '也', '很']
            },
            {
              key: '6',
              type: '代词',
              detail: ['她', '自己', '一样', '我', '那', '它']
            },
            {
              key: '7',
              type: '时间修饰词',
              detail: ['将来']
            },
            {
              key: '8',
              type: '并列词',
              detail: []
            },
            {
              key: '9',
              type: '介词',
              detail: []
            }
          ],
          totalWords: 44,
          totalSent: 5
        },
        {
          input:
            '我印象最深的旅游就是去泰山，泰山不只一座山,有好多大大小小的山峰不计其数。山峰上是无数块奇形怪状的石头,有的石头缝里还会长小树。我妈妈说身强体壮的男子汉都是要爬到山顶的，可是爬泰山真的太累了，我累的满头大汗，我再也不想去了。不过到了山顶云雾缭绕好美好美，果然付出都会有回报的。 我希望将来有一天，我自己能养几只小白兔，我会让妈妈买胡萝卜给它，把它养的胖胖的！那肯定很有趣。',
          result: [
            {
              key: '1',
              type: '名词',
              detail: [
                '小树',
                '满头大汗',
                '石头缝',
                '山峰',
                '山',
                '石头',
                '山顶',
                '会长',
                '泰山',
                '云雾',
                '美',
                '印象',
                '妈妈',
                '男子汉'
              ]
            },
            {
              key: '2',
              type: '动词',
              detail: [
                '不想',
                '是',
                '要',
                '付出',
                '有',
                '累',
                '旅游',
                '回报',
                '到',
                '爬',
                '会',
                '说',
                '去',
                '缭绕'
              ]
            },
            {
              key: '3',
              type: '形容词',
              detail: ['累', '美好', '好']
            },
            {
              key: '4',
              type: '成语',
              detail: ['奇形怪状', '不计其数']
            },
            {
              key: '5',
              type: '副词',
              detail: [
                '还',
                '再也',
                '都',
                '就是',
                '太',
                '不',
                '真的',
                '只',
                '最深',
                '果然'
              ]
            },
            {
              key: '6',
              type: '代词',
              detail: ['我']
            },
            {
              key: '7',
              type: '时间修饰词',
              detail: []
            },
            {
              key: '8',
              type: '并列词',
              detail: ['不过', '可是']
            },
            {
              key: '9',
              type: '介词',
              detail: []
            }
          ],
          totalWords: 46,
          totalSent: 4
        },
        {
          input:
            '我的心愿就是想拥有一双属于我自己的滑冰鞋。每当爸爸妈妈带我去广场玩的时候，都有许多小朋友穿着自己的滑冰鞋在广场上滑来滑去，真是太快乐了。小朋友们穿的滑冰鞋有红色的、黄色的、粉色的、紫色的、蓝色的、橙色的……真是五彩缤纷，各式各样！我看着他们在广场上自由的穿梭，真是羡慕呀！我好想有一双属于我的、独一无二的滑冰鞋。 我希望将来有一天，我自己能养几只小白兔，我会让妈妈买胡萝卜给它，把它养的胖胖的！那肯定很有趣。',
          result: [
            {
              key: '1',
              type: '名词',
              detail: [
                '爸爸妈妈',
                '真是太',
                '红色',
                '时候',
                '带我去',
                '紫色',
                '粉色',
                '滑冰鞋',
                '心愿',
                '蓝色',
                '广场',
                '橙色',
                '黄色',
                '朋友'
              ]
            },
            {
              key: '2',
              type: '动词',
              detail: [
                '玩',
                '想',
                '穿梭',
                '看着',
                '拥有',
                '有',
                '羡慕',
                '穿',
                '穿着',
                '属于'
              ]
            },
            {
              key: '3',
              type: '形容词',
              detail: ['好', '快乐', '自由']
            },
            {
              key: '4',
              type: '成语',
              detail: ['各式各样', '独一无二', '五彩缤纷']
            },
            {
              key: '5',
              type: '副词',
              detail: ['就是', '真是', '都']
            },
            {
              key: '6',
              type: '代词',
              detail: ['自己', '我', '他们']
            },
            {
              key: '7',
              type: '时间修饰词',
              detail: []
            },
            {
              key: '8',
              type: '并列词',
              detail: []
            },
            {
              key: '9',
              type: '介词',
              detail: []
            }
          ],
          totalWords: 36,
          totalSent: 5
        },
        {
          input:
            '我有一个小小的心愿，我想有一只聪明伶俐的精灵。它可以帮我写所有的作业，还可以给我画上翅膀，带着我在天空上自由自在的飞翔！每天晚上我可以对他说我的心里话，而他又不会告诉别人。我会对它非常好，把自己的零食分享给它，我们是最好的朋友。我希望明天睁开眼睛，就有一直精灵在我的床边。',
          result: [
            {
              key: '1',
              type: '名词',
              detail: [
                '零食',
                '朋友',
                '飞翔',
                '精灵',
                '心愿',
                '睁开眼睛',
                '床边',
                '我会',
                '作业',
                '心里话',
                '翅膀'
              ]
            },
            {
              key: '2',
              type: '动词',
              detail: [
                '想',
                '是',
                '帮',
                '希望',
                '写',
                '有',
                '分享',
                '不会',
                '画',
                '说',
                '告诉',
                '带'
              ]
            },
            {
              key: '3',
              type: '形容词',
              detail: ['好', '最好']
            },
            {
              key: '4',
              type: '成语',
              detail: ['自由自在', '聪明伶俐']
            },
            {
              key: '5',
              type: '副词',
              detail: ['一直', '就', '还', '非常', '又']
            },
            {
              key: '6',
              type: '代词',
              detail: ['别人', '自己', '我们', '我', '他', '它']
            },
            {
              key: '7',
              type: '时间修饰词',
              detail: ['明天']
            },
            {
              key: '8',
              type: '并列词',
              detail: ['而', '可以']
            },
            {
              key: '9',
              type: '介词',
              detail: []
            }
          ],
          totalWords: 42,
          totalSent: 5
        }
      ]
    };
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentData, setCurrentData] = useState(staticData.data[currentIndex]);

  const handleRandomInstance = useCallback(() => {
    setCurrentIndex((c) => {
      if (c + 1 >= staticData.data.length) {
        c = 0;
      } else {
        c += 1;
      }
      setCurrentData(staticData.data[c]);
      return c;
    });
  }, [staticData.data]);

  return (
    <StyledTalFigurativeWrapper>
      <div className="refresh-demo" onClick={() => handleRandomInstance()}>
        <Icon type="sync" />
        <span>换一个实例</span>
      </div>
      <div className="demo-content">
        <div className="demo-input">{currentData.input}</div>
        <div className="demo-result">
          <p className="result-title">识别结果</p>
          <div className="result-summarize">
            <div>
              总句数:
              {currentData.totalSent}
            </div>
            <div>
              词汇量:
              {currentData.totalWords}
            </div>
          </div>
          <div className="result-detial">
            <Table
              columns={staticData.columns}
              dataSource={currentData.result}
              size="small"
              pagination={false}
            />
          </div>
        </div>
      </div>
    </StyledTalFigurativeWrapper>
  );
});

export default TalFigurative;
